import { asString, loadedDefinedMap, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import type { Icon } from "common/components/icons";
import { ActionSource, LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { Appearance } from "generator/components/button-appearance";
import { Mood } from "generator/components/mood";
import { definedMapWithDefault } from "common/Support";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useForceValueProducers } from "hooks/use-value-producers";
import { ButtonBarView } from "webapp/ui/views/button-bar/button-bar-view";

export const ButtonBarMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [
            titleValue,
            appearanceValue,
            floatingIconValue,
            onTapLeft,
            titleValueRight,
            appearanceValueRight,
            floatingIconValueRight,
            onTapRight,
            moodValueLeft,
            moodValueRight,
        ],
    ] = useForceValueProducers(getValueProducers, force, ctx);

    const {
        onClick: onClickLeft,
        targetURL: targetURLLeft,
        actionIsVisible: leftIsVisible,
    } = useOnClickFromAction(onTapLeft, ActionSource.Button, ctx, env);

    const {
        onClick: onClickRight,
        targetURL: targetURLRight,
        actionIsVisible: rightIsVisible,
    } = useOnClickFromAction(onTapRight, ActionSource.Button, ctx, env);

    if (titleValue === LOADING || onTapLeft === LOADING) {
        return env.renderProgress();
    }
    if (!leftIsVisible && !rightIsVisible) {
        return null;
    }

    const appearance = loadedDefinedMapWithDefault(appearanceValue, Appearance.Filled, asString) as Appearance;
    const moodLeft = loadedDefinedMapWithDefault(moodValueLeft, Mood.Default, asString) as Mood;
    const floatingIcon = loadedDefinedMap(floatingIconValue, asString) as Icon | undefined;
    const title = definedMapWithDefault(titleValue, "", asString);

    const appearanceRight = loadedDefinedMapWithDefault(
        appearanceValueRight,
        Appearance.Filled,
        asString
    ) as Appearance;
    const moodRight = loadedDefinedMapWithDefault(moodValueRight, Mood.Default, asString) as Mood;

    const floatingIconRight = loadedDefinedMap(floatingIconValueRight, asString) as Icon | undefined;
    const titleRight = definedMapWithDefault(titleValueRight, "", asString);

    return (
        <ButtonBarView
            titleLeft={title}
            urlLeft={targetURLLeft}
            iconLeft={floatingIcon}
            moodLeft={moodLeft}
            appearanceLeft={appearance}
            onClickLeft={onClickLeft}
            titleRight={titleRight}
            urlRight={targetURLRight}
            iconRight={floatingIconRight}
            moodRight={moodRight}
            appearanceRight={appearanceRight}
            onClickRight={onClickRight}
            appKind={env.appEnvironment.appKind}
        />
    );
};
